import React, { useState, useEffect, useRef } from 'react'
import { Col, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import MAndEForm from './MAndEForm'
import MAndEView from './MAndEView'
import {
  DeleteAssessmentMAndEManageCBTeam,
  GetAssessmentMAndEManageCBTeam,
  SaveAssessmentMAndEForm,
  SaveAssessmentMAndEManageCBTeam,
  SendAssessmentMAndEForm,
} from '../../redux/actions/assessment'
import EditButton from '../../components/buttons/editButton/EditButton'
import MAndERejectWidget from './MAndERejectWidget'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { DATE_FORMAT } from '../../constants/date'
import moment from 'moment'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../constants/pathname'
import MAndEFManageCBTeamTable from './MAndEFManageCBTeamTable'
import MAndEFManageCBTeamForm from './MAndEFManageCBTeamForm'

export default function MAndEManageCBTeamWidget({ schema, projectCode, ...props }) {
  const history = useHistory()

  const { register, handleSubmit, errors, control, setValue, reset, clearErrors, getValues } =
    useForm()

  const [formSchema, setFormSchema] = useState(schema)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isLoading, setIsLoading] = useState()

  const [dataList, setDataList] = useState([])
  const [isAddNew, setIsAddNew] = useState(false)
  const [rowData, setRowData] = useState()
  const [editId, setEditId] = useState()
  const [editSchema, setEditSchema] = useState()
  const [request, setRequest] = useState()

  const [deleteId, setDeleteId] = useState()
  const [isShowDeleteConfirm, setIsShowDeleteConfirm] = useState(false)

  useEffect(() => {
    if (formSchema) {
      setFormSchema(formSchema)
      setDataList(formSchema.values)
    }
  }, [formSchema])

  const handleCallGetService = async (projectCode, id) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await GetAssessmentMAndEManageCBTeam(projectCode, id)
      if (response) {
        setEditSchema(response.forms.form)

        // notification.open('success', {
        //   title: SAVE_SUCCESS_MSG,
        //   duration: 5000,
        // })
      } else {
        notification.open('error', {
          title: response?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleCallSaveService = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await SaveAssessmentMAndEManageCBTeam(request)
      if (response) {
        setFormSchema(response.forms.form)
        setEditSchema()
        setEditId()
        setRequest()
        setIsAddNew(false)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: response?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleCallDeleteService = async (id) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await DeleteAssessmentMAndEManageCBTeam(projectCode, id)
      if (response) {
        setFormSchema(response.forms.form)
        setDeleteId()

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: response?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsShowDeleteConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('onSubmit:', data)

    let req = {
      projectCode: projectCode,
      id: editId || null,
      preName: data.preName,
      firstName: data.firstName,
      lastName: data.lastName,
      position: data.position,
      mobileNumber: data.mobileNumber,
      email: data.email,
      organization: data.organization,
      expertise: data.expertise,
    }

    console.log('req : ', req)
    setRequest(req)

    setIsShowConfirm(true)
  }

  const handleOnEdit = (id) => {
    setEditId(id)
    handleCallGetService(projectCode, id)
  }

  const handleDelete = (id) => {
    setDeleteId(id)
    setIsShowDeleteConfirm(true)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      {(editSchema || isAddNew) && (
        <>
          <MAndEFManageCBTeamForm
            schema={isAddNew ? formSchema : editSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            onSubmit={handleSubmit(onSubmit)}
            onCancel={() => {
              setEditSchema()
              setEditId()
              setIsAddNew(false)
            }}
          />

          <br />
        </>
      )}

      <Panel
        shaded
        // collapsible
        // defaultExpanded
        header={<b>{formSchema?.header || ''}</b>}
        bordered
      >
        <div style={{ textAlign: 'right' }}>
          <SaveButton
            icon={'plus'}
            onClick={() => setIsAddNew(true)}
            style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
          >
            เพิ่มรายการ
          </SaveButton>
        </div>

        <MAndEFManageCBTeamTable
          dataList={dataList}
          onEdit={(id) => handleOnEdit(id)}
          onDelete={(id) => handleDelete(id)}
        />
      </Panel>

      <ConfirmWidget
        title={'ยืนยัน'}
        show={isShowConfirm}
        detail={`ยืนยันการบันทึก`}
        onCancle={() => {
          setIsShowConfirm(false)
        }}
        onConfirm={() => {
          handleCallSaveService(request)
        }}
      />

      <ConfirmWidget
        title={'ยืนยัน'}
        show={isShowDeleteConfirm}
        detail={`ยืนยันการลบ`}
        onCancle={() => {
          setIsShowDeleteConfirm(false)
        }}
        onConfirm={() => {
          handleCallDeleteService(deleteId)
        }}
      />
    </>
  )
}
